import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'
import SupportChat from './SupportChat'
import './Layout.css'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
      <SupportChat />
    </div>
  )
}

export default Layout
